import styled from 'styled-components';

const PreloaderStyle = styled.section`
	--preloaderInnerPadTB: var(--sp6x);
	--elemHeight: var(--sp37x);

	--elemDistance: var(--sp4x);

	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100dvh;
	z-index: 9999999;

	display: flex;
	flex-direction: column;
	flex: 1;

	background-color: var(--black1000);
	overflow: hidden !important;
	pointer-events: none;
	user-select: none;
	cursor: default;

	transform: translate3d(0, 0, 0);
	transition: transform 0.8s ease-in;
	will-change: transform, opacity;
	backface-visibility: hidden;
	isolation: isolate;
	contain: strict;

	&.closed-load-anim {
		transform: translate3d(0, -100%, 0);
	}

	.logo-animation-inner-block {
		display: flex;
		justify-content: space-between;
		gap: var(--sp2x);
	}

	.elem-block {
		position: relative;
		width: calc((100% / 7) - (6 * (var(--sp2x)) / 7));
		display: flex;
		justify-content: center;
		overflow: hidden;

		svg {
			height: var(--elemHeight);

			&:last-child {
				width: 100%;
				position: absolute;
				top: 0;
				transform: translateY(calc(100% + var(--elemDistance)));
			}
		}

		&:nth-child(1) {
			svg {
				&:first-child {
					animation: anim1Double 1s 0.3s ease-in-out forwards;
				}

				&:last-child {
					animation: anim2Double 1s 0.3s ease-in-out forwards;
				}
			}
		}

		&:nth-child(2) {
			svg {
				&:first-child {
					animation: anim1Double 1s 0.45s ease-in-out forwards;
				}

				&:last-child {
					animation: anim2Double 1s 0.45s ease-in-out forwards;
				}
			}
		}

		&:nth-child(3) {
			svg {
				&:first-child {
					animation: anim1Double 1s 0.6s ease-in-out forwards;
				}

				&:last-child {
					animation: anim2Double 1s 0.6s ease-in-out forwards;
				}
			}
		}

		&:nth-child(4) {
			svg {
				&:first-child {
					animation: anim1Double 1s 0.75s ease-in-out forwards;
				}

				&:last-child {
					animation: anim2Double 1s 0.75s ease-in-out forwards;
				}
			}
		}

		&:nth-child(5) {
			svg {
				&:first-child {
					animation: anim1Double 1s 0.9s ease-in-out forwards;
				}

				&:last-child {
					animation: anim2Double 1s 0.9s ease-in-out forwards;
				}
			}
		}

		&:nth-child(6) {
			svg {
				&:first-child {
					animation: anim1Double 1s 1.05s ease-in-out forwards;
				}

				&:last-child {
					animation: anim2Double 1s 1.05s ease-in-out forwards;
				}
			}
		}

		&:nth-child(7) {
			svg {
				&:first-child {
					animation: anim1Double 1s 1.2s ease-in-out forwards;
				}

				&:last-child {
					animation: anim2Double 1s 1.2s ease-in-out forwards;
				}
			}
		}
	}

	&.retrigger {
		.elem-block {
			&:nth-child(1) {
				svg {
					&:first-child {
						animation: anim1 1s 0.3s ease-in-out forwards;
					}

					&:last-child {
						animation: anim2 1s 0.3s ease-in-out forwards;
					}
				}
			}

			&:nth-child(2) {
				svg {
					&:first-child {
						animation: anim1 1s 0.45s ease-in-out forwards;
					}

					&:last-child {
						animation: anim2 1s 0.45s ease-in-out forwards;
					}
				}
			}

			&:nth-child(3) {
				svg {
					&:first-child {
						animation: anim1 1s 0.6s ease-in-out forwards;
					}

					&:last-child {
						animation: anim2 1s 0.6s ease-in-out forwards;
					}
				}
			}

			&:nth-child(4) {
				svg {
					&:first-child {
						animation: anim1 1s 0.75s ease-in-out forwards;
					}

					&:last-child {
						animation: anim2 1s 0.75s ease-in-out forwards;
					}
				}
			}

			&:nth-child(5) {
				svg {
					&:first-child {
						animation: anim1 1s 0.9s ease-in-out forwards;
					}

					&:last-child {
						animation: anim2 1s 0.9s ease-in-out forwards;
					}
				}
			}

			&:nth-child(6) {
				svg {
					&:first-child {
						animation: anim1 1s 1.05s ease-in-out forwards;
					}

					&:last-child {
						animation: anim2 1s 1.05s ease-in-out forwards;
					}
				}
			}

			&:nth-child(7) {
				svg {
					&:first-child {
						animation: anim1 1s 1.2s ease-in-out forwards;
					}

					&:last-child {
						animation: anim2 1s 1.2s ease-in-out forwards;
					}
				}
			}
		}
	}

	.container-wrapper {
		display: flex;
		flex-direction: column;
		flex: 1;
	}

	.preloader-inner-wrapper {
		display: flex;
		flex-direction: column;
		flex: 1;
		padding: var(--preloaderInnerPadTB) 0;
	}

	.logo-animation-block {
		display: flex;
		flex-direction: column;
		flex: 1;
		justify-content: space-between;
	}

	@keyframes anim1Double {
		0% {
			transform: translateY(0);
		}

		100% {
			transform: translateY(calc(-100% - var(--elemDistance)));
		}
	}

	@keyframes anim2Double {
		0% {
			transform: translateY(calc(100% + var(--elemDistance)));
		}

		100% {
			transform: translateY(0);
		}
	}

	@keyframes anim1 {
		0% {
			transform: translateY(0);
		}

		100% {
			transform: translateY(calc(-100% - var(--elemDistance)));
		}
	}

	@keyframes anim2 {
		0% {
			transform: translateY(calc(100% + var(--elemDistance)));
		}

		100% {
			transform: translateY(0);
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--preloaderInnerPadTB: var(--sp5x);
		--elemHeight: var(--sp27x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--preloaderInnerPadTB: var(--sp5x);
		--elemHeight: var(--sp27x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--preloaderInnerPadTB: var(--sp4x);
		--elemHeight: var(--sp19x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--preloaderInnerPadTB: var(--sp3x);
		--elemHeight: var(--sp18x);
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--preloaderInnerPadTB: var(--sp3x);
		--elemHeight: var(--sp14x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--preloaderInnerPadTB: var(--sp3x);
		--elemHeight: var(--sp11x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--preloaderInnerPadTB: var(--sp3x);
		--elemHeight: var(--sp5x);

		--elemDistance: var(--sp1x);
	}
`;

export default PreloaderStyle;
